import React, { useEffect, useState } from 'react';

import { useGeoBlocking } from '../hooks/useGeoBlocking';
import { useEssential } from './App';

import { KioskData } from './components/Kiosk/KioskData';
import { Loading } from './components/Base/Loading';
import { useOwnedKiosk } from '../hooks/kiosk';
import { KioskSelector } from './components/Kiosk/KioskSelector';
import { useKioskSelector } from '../hooks/useKioskSelector';

const SCardPortal: React.FC = props => {
  const { accountData, priceLoading } = useEssential();
  const {
    data: ownedKiosk,
    isLoading,
    refetch: refetchOwnedKiosk,
  } = useOwnedKiosk(accountData.address);

  const { selected, setSelected, showKioskSelector } = useKioskSelector(
    accountData.address
  );

  const [invalid, setInvalid] = useState('');

  const isBlocked = useGeoBlocking();

  useEffect(() => {
    if (isBlocked === null || priceLoading) {
      setInvalid('Loading');
      return;
    }

    if (!accountData.address) {
      setInvalid('Please connect wallet');
      return;
    }
    setInvalid('');
  }, [isBlocked, priceLoading, accountData.address]);

  // Return loading state.
  if (isLoading) return <Loading />;

  if (!ownedKiosk?.kioskId)
    return (
      <div className="flex justify-center min-h-[300px] items-center h-full">
        {' '}
        You don't have any S Card.{' '}
      </div>
    );

  // kiosk management screen.
  return (
    <div className={`section-container py-5 sm:py-10 sm:px-14 px-5 relative`}>
      {showKioskSelector && selected && (
        <div className="px-4">
          <KioskSelector
            caps={ownedKiosk.caps}
            selected={selected}
            setSelected={setSelected}
          />
        </div>
      )}
      {selected && accountData.address && (
        <KioskData kioskId={selected.kioskId} kioskCap={selected} address={accountData.address} />
      )}
    </div>
  );
};

export default SCardPortal;
